import { render, staticRenderFns } from "./OrderTransactions.vue?vue&type=template&id=8adac640&scoped=true&"
import script from "./OrderTransactions.vue?vue&type=script&lang=js&"
export * from "./OrderTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adac640",
  null
  
)

export default component.exports